export enum ERROR_MESSAGES {
  PET_NOT_FOUND = 'Pet not found.',
  SELECTED_POLICY_NOT_FOUND = 'Selected policy not found.',
  NO_ACTIVE_PINIA_STORES = 'There are no active stores.',
  PINIA_STORES_NOT_FOUND = 'Stores not found.',
  USERNAME_NOT_FOUND = 'Username not found.'
}
